(() => {
  const root = document.getElementById('IpertechExitOffer');
  if (!root) return;

  const closeBtn = document.getElementById('IpertechExitOfferClose');
  const dismissBtn = document.getElementById('IpertechExitOfferDismiss');
  const ctaBtn = document.getElementById('IpertechExitOfferCta');

  const STORAGE_KEYS = {
    dismissed: 'ipertech_exit_offer_dismissed',
    claimed: 'ipertech_exit_offer_claimed',
    shown: 'ipertech_exit_offer_shown'
  };

  const MOBILE_BREAKPOINT = 990;
  const INITIAL_DELAY = 7000;

  let isVisible = false;
  let hasTriggered = false;
  let lastScrollY = window.scrollY;
  let maxScrollY = window.scrollY;
  let mobileIntentArmed = false;

  function hasAlreadyBeenHandled() {
    return (
      localStorage.getItem(STORAGE_KEYS.dismissed) === '1' ||
      localStorage.getItem(STORAGE_KEYS.claimed) === '1' ||
      localStorage.getItem(STORAGE_KEYS.shown) === '1'
    );
  }

  async function cartHasItems() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) return false;

      const cart = await response.json();
      return Number(cart.item_count) > 0;
    } catch (error) {
      return Number(root.dataset.cartCount || 0) > 0;
    }
  }

  async function showOffer() {
    if (isVisible || hasTriggered || hasAlreadyBeenHandled()) return;

    const hasItems = await cartHasItems();
    if (!hasItems) return;

    hasTriggered = true;
    isVisible = true;

    localStorage.setItem(STORAGE_KEYS.shown, '1');

    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(() => {
      root.classList.add('is-visible');
    });
  }

  function hideOffer(markAsDismissed = false) {
    if (!isVisible && !markAsDismissed) return;

    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');

    window.setTimeout(() => {
      root.hidden = true;
      isVisible = false;
    }, 220);

    if (markAsDismissed) {
      localStorage.setItem(STORAGE_KEYS.dismissed, '1');
    }
  }

  function isDesktop() {
    return window.innerWidth >= MOBILE_BREAKPOINT;
  }

  function handleDesktopExitIntent(event) {
    if (!isDesktop()) return;
    if (hasAlreadyBeenHandled()) return;

    const leavingTopEdge =
      event.clientY <= 8 &&
      !event.relatedTarget &&
      !event.toElement;

    if (leavingTopEdge) {
      showOffer();
    }
  }

  function handleMobileIntent() {
    if (isDesktop()) return;
    if (hasAlreadyBeenHandled()) return;
    if (!mobileIntentArmed) return;

    const currentY = window.scrollY;
    const delta = lastScrollY - currentY;

    if (currentY > maxScrollY) {
      maxScrollY = currentY;
    }

    const strongUpwardMove = delta > 28;
    const userHasExplored = maxScrollY > 220;
    const nearTopAgain = currentY < 120;

    if (strongUpwardMove && userHasExplored && nearTopAgain) {
      showOffer();
      mobileIntentArmed = false;
    }

    lastScrollY = currentY;
  }

  closeBtn?.addEventListener('click', () => hideOffer(true));
  dismissBtn?.addEventListener('click', () => hideOffer(true));

  ctaBtn?.addEventListener('click', () => {
    localStorage.setItem(STORAGE_KEYS.claimed, '1');
  });

  document.addEventListener('mouseout', handleDesktopExitIntent, { passive: true });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isVisible) {
      hideOffer(true);
    }
  });

  window.addEventListener('scroll', handleMobileIntent, { passive: true });

  window.setTimeout(() => {
    mobileIntentArmed = true;
  }, INITIAL_DELAY);
})();